import {
  IsString,
  IsNotEmpty,
  IsOptional,
  IsInt,
  IsBoolean,
  Min,
  MaxLength,
} from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

export class CreateMenuGroupDto {
  @ApiProperty({
    example: 'LOGISTIC',
    description: 'Nombre del grupo de menú',
  })
  @IsString()
  @IsNotEmpty()
  @MaxLength(100)
  readonly nombre!: string;

  @ApiPropertyOptional({
    example: 1,
    description: 'Orden de visualización en el menú (menor = primero)',
    default: 0,
  })
  @IsOptional()
  @IsInt()
  @Min(0)
  readonly orden?: number;

  @ApiPropertyOptional({
    example: false,
    description: 'Si el grupo corresponde a un sistema integrado (embebido)',
    default: false,
  })
  @IsOptional()
  @IsBoolean()
  readonly integration?: boolean;

  @ApiPropertyOptional({
    example: 'https://satelite.ejemplo.cl/embed-token',
    description:
      'URL del token del sistema integrado. Solo aplica si integration = true',
  })
  @IsOptional()
  @IsString()
  @MaxLength(255)
  readonly url_token?: string;

  @ApiPropertyOptional({
    example: 'clave-secreta-del-proveedor',
    description:
      'Credencial (X-API-Key) para pedir el token del sistema integrado. Solo aplica si integration = true. Nunca se devuelve en las respuestas (ver hasApiKey)',
  })
  @IsOptional()
  @IsString()
  @MaxLength(255)
  readonly api_key?: string;

  @ApiPropertyOptional({
    example: 'clave-de-sesiones-del-proveedor',
    description:
      'Credencial (X-API-Key) para cerrar/alargar sesiones embebidas del sistema integrado. Solo aplica si integration = true. Nunca se devuelve en las respuestas (ver hasSessionApiKey)',
  })
  @IsOptional()
  @IsString()
  @MaxLength(255)
  readonly session_api_key?: string;
}

export class UpdateMenuGroupDto {
  @ApiPropertyOptional({
    example: 'LOGISTIC',
    description: 'Nombre del grupo de menú',
  })
  @IsOptional()
  @IsString()
  @IsNotEmpty()
  @MaxLength(100)
  readonly nombre?: string;

  @ApiPropertyOptional({
    example: 1,
    description: 'Orden de visualización en el menú (menor = primero)',
  })
  @IsOptional()
  @IsInt()
  @Min(0)
  readonly orden?: number;

  @ApiPropertyOptional({
    example: false,
    description: 'Si el grupo corresponde a un sistema integrado (embebido)',
  })
  @IsOptional()
  @IsBoolean()
  readonly integration?: boolean;

  @ApiPropertyOptional({
    example: 'https://satelite.ejemplo.cl/embed-token',
    description:
      'URL del token del sistema integrado. Solo aplica si integration = true',
  })
  @IsOptional()
  @IsString()
  @MaxLength(255)
  readonly url_token?: string;

  @ApiPropertyOptional({
    example: 'clave-secreta-del-proveedor',
    description:
      'Credencial (X-API-Key) para pedir el token del sistema integrado. Dejar sin enviar para no modificar la existente; enviar string vacío para borrarla. Nunca se devuelve en las respuestas (ver hasApiKey)',
  })
  @IsOptional()
  @IsString()
  @MaxLength(255)
  readonly api_key?: string;

  @ApiPropertyOptional({
    example: 'clave-de-sesiones-del-proveedor',
    description:
      'Credencial (X-API-Key) para cerrar/alargar sesiones embebidas. Dejar sin enviar para no modificar la existente; enviar string vacío para borrarla. Nunca se devuelve en las respuestas (ver hasSessionApiKey)',
  })
  @IsOptional()
  @IsString()
  @MaxLength(255)
  readonly session_api_key?: string;
}
